function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "menu-my-idp",
  "data-name": "Group 14946",
  transform: "translate(-3 -2)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_3482",
  "data-name": "Path 3482",
  d: "M15.716,16.223H8.5",
  fill: "none",
  stroke: "#505e6c",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.5
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_3483",
  "data-name": "Path 3483",
  d: "M15.716,12.037H8.5",
  fill: "none",
  stroke: "#505e6c",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.5
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_3484",
  "data-name": "Path 3484",
  d: "M11.251,7.86H8.5",
  fill: "none",
  stroke: "#505e6c",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.5
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_3485",
  "data-name": "Path 3485",
  d: "M15.908,2.75l-7.689,0a4.251,4.251,0,0,0-4.469,4.6v9.2A4.254,4.254,0,0,0,8.256,21.16l7.689,0a4.252,4.252,0,0,0,4.47-4.6v-9.2A4.255,4.255,0,0,0,15.908,2.75Z",
  fill: "none",
  stroke: "#505e6c",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.5,
  fillRule: "evenodd"
}));

function SvgMenuMyIdp(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18.165,
    height: 19.91,
    viewBox: "0 0 18.165 19.91",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuMyIdp);
export default __webpack_public_path__ + "static/media/menu-my-idp.ef379b27.svg";
export { ForwardRef as ReactComponent };